(function () {
  'use strict';

  /* mr-selleasy-reposition.js -- RC3 (2026-07-13), items 9/10 follow-up.
     QA finding: Selleasy's app embed injects its widget as a JS-appended
     child of the real <product-form> (confirmed live: the widget's actual
     tag is <lb-product-page-cross-sell-ew>, nested inside <product-form>
     right after the Add to Cart button) -- NOT into this section's
     #mr-selleasy-shell anchor div, regardless of where the selleasy_shell
     block sits in block_order. That anchor div only ever receives real
     content if Selleasy is configured to target it directly, which is not
     the case on this store. Left alone, the widget renders immediately
     after Add to Cart and BEFORE the product description -- the opposite
     of Akkas's required order (Add to Cart -> Description -> Selleasy).

     This script does not touch Selleasy's targeting, selected products,
     prices, quantities, Add All to Cart form, or app settings -- it only
     relocates the already-mounted widget element to the reserved
     #mr-selleasy-shell anchor (which already sits after the description
     block in this section's DOM), i.e. document-flow placement only. */

  function relocate(widget) {
    var shell = document.getElementById('mr-selleasy-shell');
    if (!shell || shell.contains(widget)) return;
    shell.appendChild(widget);
  }

  function init(root) {
    root = root || document;
    var existing = root.querySelector('lb-product-page-cross-sell-ew');
    if (existing) {
      relocate(existing);
      return;
    }
    var observer = new MutationObserver(function (mutations, obs) {
      var widget = document.querySelector('lb-product-page-cross-sell-ew');
      if (widget) {
        relocate(widget);
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // Safety-net only: stop observing after a generous window so this
    // doesn't run forever on products where Selleasy never mounts.
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.MRSelleasyReposition = { init: init };
})();
